/* eslint-disable max-lines-per-function */
import { ADD_FLEX, REMOVE_FLEX } from "../actions"
import defaultState from "../data"

// eslint-disable-next-line default-param-last
const rootReducer = ( state = defaultState, action ) => {
  switch (action.type) {

  case ADD_FLEX:
    return {
      ...state,
      flexes: {
        ...state.flexes,
        active: [...state.flexes.active, action.payload.flex]
      }
    }
  case REMOVE_FLEX:
    return {
      ...state,
      flexes: {
        ...state.flexes,
        active: state.flexes.active.filter(ss => ss.id !== action.payload.flex_id)
      }
    }
  case "UPDATE_TIME_INFO":
    return {
      ...state,
      game: {
        ...state.game,
        countdown: {
          ...state.game.countdown,
          timeRemaining: action.payload.updatedData 
        }
      } 
    }
  case "UPDATE_START_TIME":
    return {
      ...state,
      game: {
        ...state.game,
        countdown: {
          ...state.game.countdown,
          startTime: action.payload,
          timeRemaining: action.payload
        }
      }
    }
  case "UPDATE_QUESTION_INFO":
    return {
      ...state,
      game: {
        ...state.game,
        question: action.payload
      }
    }
  case "UPDATE_ANSWER_INFO":
    // [2, 4, 1, 3]
    // const indexes = state.game.question.answers.map(answer => action.payload.findIndex(({text}) => answer.text === text))
    
    // question.answer[1] = action.payload[2]
    // question.answer[2] = action.payload[4]
    // question.answer[3] = action.payload[1]
    // question.answer[4] = action.payload[3]

    return {
      ...state,
      game: {
        ...state.game,
        question: {
          ...state.game.question,
          answers: action.payload
        }
      }
    }
  case "UPDATE_SCORES_INFO":
    const {
      totalScores,
      questionScores,
    } = action.payload
    return {
      ...state,
      game: {
        ...state.game,
        questionScores,
        totalScores,
      }
    }
  case "UPDATE_TOTAL_PLAYERS_INFO":
    return {
      ...state,
      game: {
        ...state.game,
        totalPlayers: action.payload
      }
    }
  case "UPDATE_SKIN":
    return {
      ...state,
      game: {
        ...state.game,
        skin: action.payload,
      },
    }
  case "UPDATE_RULES_INFO":
    return {
      ...state,
      game: {
        ...state.game,
        gameMode: action.payload.gameMode,
        tagline: action.payload.tagline,
        title: action.payload.title,
      },
    }
  case "UPDATE_IS_FINAL_SCORE":
    return {
      ...state,
      game: {
        ...state.game,
        isFinalScore: action.payload,
      }
    }
  case "UPDATE_IS_REVEALED":
    return {
      ...state,
      game: {
        ...state.game,
        isRevealed: action.payload,
      }
    }

  case "START_COUNTDOWN":
    return {
      ...state,
      game: {
        ...state.game,
        countdown: {
          ...state.game.countdown,
          isStarted: true,
        }
      }
    }
  case "RESET_COUNTDOWN":
    return {
      ...state,
      game: {
        ...state.game,
        countdown: {
          ...state.game.countdown,
          isStarted: false,
        }
      }
    }

  }

  // logger.logToConsole(action.type)
  // logger.logToConsole(state)

  return { ...state, isRequesting: false }
}

export default rootReducer